/**
 * Register Page
 */

import { GuestGuard } from '@/components/auth';
import { RegisterForm } from '@/components/auth';

export default function Register() {
  return (
    <GuestGuard>
      <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 bg-gray-50">
        <RegisterForm />
      </div>
    </GuestGuard>
  );
}
